<template>
  <div>
    <ckeditor
      :editor="editor"
      :model-value="value"
      @input="changeText"
      :disabled="showReadOnly"
    ></ckeditor>
    <div v-if="showError" class="error-message" :style="{ fontSize: '14px' }">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  props: ["data", "showReadOnly"],
  methods: {
    showErrorMessage(message) {
      this.errorMessage = message;
      this.showError = true;
    },
    changeText(event) {
      this.value = event;
      this.$emit("textData", this.value);
      this.showError = false;
    },
  },
  data() {
    return {
      showError: false,
      editor: ClassicEditor,
      value: "",
      editorDisabled: true,
      errorMessage: "",
    };
  },
  
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        if (newData !== undefined && newData !== null) {
          this.value = String(newData);
        } else {
          this.value = "";
        }
      },
    },
  },
};
</script>

<style scoped>
:deep(.ck-editor__editable_inline),
:deep(.ck-editor__editable),
:deep(.ck-content) {
  min-height: 120px;
  max-height: 300px;
  font-size: 14px !important;
  color: #272727 !important;
  line-height: 1.5 !important;
}

:deep(.ck-content p),
:deep(.ck-editor__editable p) {
  font-size: 14px !important;
  margin-bottom: 4px !important;
}

:deep(.ck-content h1),
:deep(.ck-content h2),
:deep(.ck-content h3),
:deep(.ck-content h4) {
  font-size: 15px !important;
  font-weight: 600 !important;
}

.error-message {
  color: #cf0707;
  font-size: 13px;
  margin-top: 4px;
}
</style>
